import { useQuery } from 'react-query';
import { queryAllProspects } from './useProspects.query';
import { UseProspectsQueryParams, UseProspectsResponse } from './useProspects.types';

export const ALL_PROSPECTS_QUERY_KEY = 'ALL_PROSPECTS';

export const useProspects = (params: UseProspectsQueryParams) => {
  return useQuery<UseProspectsResponse, Error>(
    [ALL_PROSPECTS_QUERY_KEY, params],
    () => queryAllProspects(params),
    {
      cacheTime: 0,
      refetchOnMount: false,
      refetchOnWindowFocus: false
    }
  );
};
